/**
 * The opening screen, while the app starts up (signing in, loading who you are). The same markup
 * as the one in index.html (shown before this code loads) and its styles there (`boot`), so it's
 * one steady screen from ServiceM8's add-on window until the app is ready.
 */
export function BootScreen() {
    return (
        <output className="boot">
            <span className="boot-spinner" />
            <span className="boot-title">Opening Outback Workbench…</span>
            <span className="boot-slow">This is taking longer than usual. If it doesn't open, close this and open Outback Workbench again.</span>
        </output>
    );
}
